export function valueNotEmpty(value: string | number) {
  if (typeof value === 'string') {
    return value && value.length >= 1;
  } else {
    return value !== null && value;
  }
}
